document.addEventListener('DOMContentLoaded', () => {
	const anchorLinks = document.querySelectorAll('.fiber-cta__button[href^="#"]');

	if (!anchorLinks.length) {
		return;
	}

	const getHeaderOffset = () => {
		const header = document.querySelector('.site-header, header');

		if (!header) {
			return 0;
		}

		const headerStyles = window.getComputedStyle(header);
		const isFixed = headerStyles.position === 'fixed' || headerStyles.position === 'sticky';

		return isFixed ? header.offsetHeight : 0;
	};

	anchorLinks.forEach((link) => {
		link.addEventListener('click', (event) => {
			const href = link.getAttribute('href');

			if (!href || href === '#') {
				return;
			}

			const targetId = href.slice(1);
			const target = document.getElementById(targetId);

			if (!target) {
				return;
			}

			event.preventDefault();

			const offset = getHeaderOffset();
			const targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;

			window.scrollTo({
				top: targetTop,
				behavior: 'smooth',
			});
		});
	});
});